import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const SoftwareDev = () => {

  // ✅ SYSTEM-BASED PROJECTS (STRONG POSITIONING)
  const projects = [
    {
      title: "Custom CRM System",
      desc: "A scalable customer relationship management system designed to manage leads, clients, and sales pipelines.",
      link: "#",
    },
    {
      title: "ERP Management System",
      desc: "Enterprise-level software for managing operations, inventory, and business workflows.",
      link: "#",
    },
    {
      title: "SaaS Web Platform",
      desc: "Cloud-based SaaS product with user authentication, dashboards, and subscription model.",
      link: "#",
    },
    {
      title: "Inventory Management System",
      desc: "Real-time tracking system for managing stock, orders, and analytics.",
      link: "#",
    },
  ];

  // ✅ TESTIMONIALS (ENTERPRISE STYLE)
  const testimonials = [
    {
      name: "Bilal Ahmed",
      role: "Company Director",
      feedback:
        "Their understanding of software architecture and scalability is impressive.",
    },
    {
      name: "Hassan Raza",
      role: "Operations Manager",
      feedback:
        "They provided a structured approach to building our internal systems.",
    },
    {
      name: "Ayesha Khan",
      role: "Startup Founder",
      feedback:
        "Professional team with strong technical expertise in building complex solutions.",
    },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-indigo-600/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Build Scalable <span className="text-indigo-400">Software Solutions</span>
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We develop powerful, scalable, and secure software systems tailored
            to your business needs.
          </p>

          <p className="mt-4 text-indigo-400 font-medium">
            ⚙️ Actively building custom software solutions — open for new projects.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-indigo-500 rounded-full hover:scale-105 transition">
              Build Your System
            </Link>

            <a
              href="https://calendly.com/thelogicwaves/30min"
              target="_blank"
              rel="noreferrer"
              className="px-8 py-4 border rounded-full hover:bg-white/10 transition"
            >
              Book a Consultation
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 px-6 max-w-5xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8">Beyond Code — We Build Systems</h2>

        <p className="text-gray-300 leading-relaxed mb-6">
          Our software solutions are designed to solve real business challenges,
          automate workflows, and improve efficiency.
        </p>

        <p className="text-gray-400">
          Whether you're building a startup product or enterprise system,
          we create software that scales with your growth.
        </p>
      </section>

      {/* FEATURES */}
      <section className="py-24 px-6">
        <h2 className="text-4xl font-bold text-center mb-16">What We Build</h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            { title: "Custom Software", desc: "Tailored solutions built for your business." },
            { title: "Enterprise Systems", desc: "ERP, CRM, and large-scale applications." },
            { title: "SaaS Platforms", desc: "Cloud-based subscription products." },
            { title: "Automation Tools", desc: "Streamline workflows and reduce manual work." },
            { title: "Secure Architecture", desc: "Built with security and reliability in mind." },
            { title: "API Integrations", desc: "Connect systems with powerful integrations." },
          ].map((item, i) => (
            <div key={i} className="bg-white/5 p-6 rounded-2xl border border-white/10 hover:scale-105 transition">
              <h3 className="text-xl font-semibold mb-3 text-indigo-400">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-24 px-6 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-16">Our Development Process</h2>

        <div className="grid md:grid-cols-4 gap-10 max-w-6xl mx-auto">
          {["Planning", "Architecture", "Development", "Deployment"].map((step, i) => (
            <div key={i}>
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-indigo-500 text-xl font-bold">
                {i + 1}
              </div>
              <p className="text-gray-300">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROJECTS */}
      <ProjectsSection projects={projects} />

      {/* TESTIMONIALS */}
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-indigo-500 to-purple-600 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Let’s Build Your Software Product
        </h2>

        <p className="text-gray-200 mb-8">
          From idea to execution — we help you create scalable digital systems.
        </p>

        <Link to="/contact" className="bg-black px-6 py-3 rounded-full hover:scale-105 transition">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default SoftwareDev;